"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PausableUpgradeable__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [],
  name: "EnforcedPause",
  type: "error"
}, {
  inputs: [],
  name: "ExpectedPause",
  type: "error"
}, {
  inputs: [],
  name: "InvalidInitialization",
  type: "error"
}, {
  inputs: [],
  name: "NotInitializing",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint64",
    name: "version",
    type: "uint64"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Paused",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Unpaused",
  type: "event"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}];
class PausableUpgradeable__factory {
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.PausableUpgradeable__factory = PausableUpgradeable__factory;
_defineProperty(PausableUpgradeable__factory, "abi", _abi);